import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import {
    Box, Button,
    Checkbox,
    CircularProgress,
    Stack,
    TextField,
    Typography
} from '@mui/material';
import PropTypes from 'prop-types';
import { Controller, useForm } from 'react-hook-form';
import { useApiScopes, useCreateApiKey } from '../hooks';
import { ApiKeyFormSchema } from '../schemas/ApiKeyFormSchema';
import CreateApiKeyFormSkeleton from '../skeletons/CreateApiKeyFormSkeleton';



CreateApiKeyForm.propTypes = {
    handleCloseDialog: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    setApiKeyInfo: PropTypes.func.isRequired,
}

export default function CreateApiKeyForm({ open, handleCloseDialog, setApiKeyInfo }) {

    const { scopes: scopesArray, isLoading } = useApiScopes(open);
    const { createApiKey, isLoading: isCreating } = useCreateApiKey();

    const {
        control,
        handleSubmit,
        watch,
        setValue,
        formState: { errors }
    } = useForm({
        resolver: yupResolver(ApiKeyFormSchema),
        defaultValues: {
            name: '',
            scopes: []
        }
    });

    const watchedScopes = watch('scopes');

    const handleScopeChange = (scopeName) => {
        const currentScopes = watchedScopes || [];
        const newScopes = currentScopes.includes(scopeName)
            ? currentScopes.filter(name => name !== scopeName)
            : [...currentScopes, scopeName];

        setValue('scopes', newScopes);
    };

    const onSubmit = (formData) => {
        createApiKey(formData, {
            onSuccess: (data) => {
                handleCloseDialog();
                setApiKeyInfo(data);
            }
        });
    };

    return (
        <form onSubmit={handleSubmit(onSubmit)}>
            <Stack gap={2}>
                <Controller
                    name="name"
                    control={control}
                    render={({ field }) => (
                        <TextField
                            {...field}
                            label="Nome"
                            size='small'
                            fullWidth
                            variant="outlined"
                            placeholder='Digite aqui um nome para sua chave de api'
                            error={!!errors.name}
                            helperText={errors.name?.message}
                        />
                    )}
                />

                <Stack>
                    <Typography variant="subtitle1" color='text.secondary'>Selecionar Escopo</Typography>
                    <Stack mt={1}>
                        {isLoading ? <CreateApiKeyFormSkeleton /> : scopesArray.map((scope) => (
                            <Box sx={{ marginLeft: -1 }} key={scope.name} display='flex' alignItems='center' gap={1}>
                                <Checkbox
                                    checked={watchedScopes?.includes(scope.name) || false}
                                    onChange={() => handleScopeChange(scope.name)}
                                    size='small'
                                    id={`scope-${scope.name}`}
                                />
                                <label htmlFor={`scope-${scope.name}`}>
                                    <Typography variant='body2'>{scope.label}</Typography>
                                </label>
                            </Box>
                        ))}
                    </Stack>
                    {errors.scopes && (
                        <Typography variant="caption" color="error" sx={{ mt: 1, ml: 1 }}>
                            {errors.scopes.message}
                        </Typography>
                    )}
                </Stack>

                <Box display='flex' gap={1} justifyContent='end'>
                    <Button
                        variant='outlined'
                        color='inherit'
                        onClick={handleCloseDialog}
                        disabled={isCreating}
                    >
                        Cancelar
                    </Button>
                    <LoadingButton
                        variant='contained'
                        type="submit"
                        loading={isCreating}
                        loadingIndicator={<CircularProgress color="inherit" size={16} />}
                        disabled={isCreating}
                    >
                        Criar Chave API
                    </LoadingButton>
                </Box>
            </Stack>
        </form>
    )
}